import { Tooltip } from "@xola/ui-kit";
import pluralize from "pluralize";
import React, { Fragment, ReactNode } from "react";
import { NoTranslate } from "@/components/Common/NoTranslate";

const VISIBLE_RECIPIENT_COUNT = 3;

export interface RecipientEntry {
    key: string;
    label: ReactNode;
    /** Shown in the overflow tooltip instead of `label`, for a label that carries a tooltip of its own. */
    tooltipLabel?: ReactNode;
}

const JoinedRecipients = ({ labels }: { labels: { key: string; label: ReactNode }[] }) => {
    return (
        <>
            {labels.map(({ key, label }, index) => (
                <Fragment key={key}>
                    {index > 0 && ", "}
                    {label}
                </Fragment>
            ))}
        </>
    );
};

/** Keeps a broadcast from stretching the badge row; the tooltip sits on the overflow text so it never nests. */
export const RecipientOverflowList = ({ recipients }: { recipients: RecipientEntry[] }) => {
    const visibleRecipients = recipients.slice(0, VISIBLE_RECIPIENT_COUNT);
    const hiddenCount = recipients.length - visibleRecipients.length;

    if (hiddenCount === 0) {
        return <JoinedRecipients labels={visibleRecipients} />;
    }

    const tooltipLabels = recipients.map(({ key, label, tooltipLabel }) => ({ key, label: tooltipLabel ?? label }));
    const allRecipients = (
        <NoTranslate className="!w-auto text-sm leading-p3">
            <JoinedRecipients labels={tooltipLabels} />
        </NoTranslate>
    );

    return (
        <span>
            <JoinedRecipients labels={visibleRecipients} />{" "}
            <Tooltip placement="top" content={allRecipients}>
                and {hiddenCount} {pluralize("other", hiddenCount)}
            </Tooltip>
        </span>
    );
};
